module.exports = __webpack_public_path__ + "static/media/tss482-australia.7793e506.jpg";